import React from 'react';
import { Hidden } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { ReactComponent as Logo } from 'assets/logo.svg';

import { HeaderItem } from './HeaderItem';
import { HeaderItemType, OnboardingScreen } from './types';
import { getOnboardingStepFromScreen } from '../../state/onboarding/sagas';
import { SelectLanguageControl } from '../../components/SelectLanguageControl/SelectLanguageControl';

const useStyles = makeStyles(theme => ({
    container: {
        borderBottom: '1px solid rgba(15, 24, 37, 0.1)',
        display: 'flex',
        flexDirection: 'row',
        height: theme.spacing(10),
        padding: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            padding: theme.spacing(0, 5),
        },
        [theme.breakpoints.down('md')]: {
            backgroundColor: '#fff',
            justifyContent: 'center',
        },
    },
    logo: {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
    },
    lang: {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
    },
    items: {
        alignItems: 'center',
        display: 'flex',
    },
    item: {
        flexBasis: theme.spacing(11),
    },
}));

const items = [
    {
        index: 1,
        text: 'onboarding:wizard.seller',
    },
    {
        index: 2,
        text: 'onboarding:wizard.store',
    },
    {
        index: 3,
        text: 'onboarding:wizard.catalog',
    },
];

const getHeaderItemType = (currentIndex: number, activeIndex: number): HeaderItemType => {
    if (currentIndex < activeIndex) {
        return HeaderItemType.COMPLETE;
    }
    if (currentIndex > activeIndex) {
        return HeaderItemType.DISABLED;
    }
    return HeaderItemType.ACTIVE;
};

interface HeaderProps {
    currentScreen: OnboardingScreen;
}

export const Header = (props: HeaderProps) => {
    const classes = useStyles();
    return (
        <div className={classes.container}>
            <Hidden xsDown>
                <div className={classes.logo}>
                    <Logo />
                </div>
            </Hidden>
            <div className={classes.items}>
                {items.map(item => {
                    const step = getOnboardingStepFromScreen(props.currentScreen);
                    const type = getHeaderItemType(item.index, step);
                    return (
                        <div key={item.index} className={classes.item}>
                            <HeaderItem index={item.index} text={item.text} type={type} />
                        </div>
                    );
                })}
            </div>
            <div className={classes.lang}>
                <SelectLanguageControl />
            </div>
        </div>
    );
};
